let settingsWrapper = $('#relation-organisation-settings-wrapper');

if(settingsWrapper.length) {
    settingsWrapper.find('form').each(function (k, v) {
        $(v).on('submit', (e) => {
            e.preventDefault()
            saveSetting($(v));
        })
    });
    settingsWrapper.find('input, select, textarea').each(function (k, v) {
        $(v).on('change', (e) => {
            e.preventDefault()
            saveSetting($(v).closest('form'));
        })
    });

    function saveSetting(form) {
        let status = form.closest('tr').find('.form-status');
        status.html('<i class="fas fa-spinner fa-spin"></i>');
        let ajaxConfig = {
            url: form.attr('action'),
            dataType: 'JSON',
            processData: false,
            contentType: false,
            data: form.getFormDataAssociative(),
            success: function (result) {
                status.html('<i class="fas fa-check text-success"></i>');
                setTimeout(function () {
                    status.html('');
                }, 1000);
            },
            error: function (error) {
                status.html('<i class="fas fa-exclamation-triangle text-danger"></i>');
            },
            fail: function (error) {
                status.html('<i class="fas fa-exclamation-triangle text-danger"></i>');
            }
        };
        $.post(ajaxConfig)
    }
}
